import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';

import { COMMIT_RATIO, MAX_SWIPE_RATIO } from './constants';

export type TSwipeConfig = {
  /** Доля ширины сообщения, на которую оно может уехать за экран */
  maxSwipeRatio?: number;
  /** Доля ширины сообщения, после которой свайп считается завершённым */
  commitRatio?: number;
};

/**
 * Пороги свайпа-репляя из RS-настройки chats.replies.swipeConfig
 */
export const useSwipeConfig = (): Required<TSwipeConfig> => {
  const { config } = useApplicationContext();

  return React.useMemo(() => {
    const { maxSwipeRatio = MAX_SWIPE_RATIO, commitRatio = COMMIT_RATIO } =
      config.get<TSwipeConfig | null>('chats.replies.swipeConfig') || {};

    return {
      maxSwipeRatio,
      commitRatio,
    };
  }, [config]);
};
